import { withLocalePrefix, type Locale } from './localePath';
import type { CareerOrganizationMeta } from './types';

export const CAREER_CATEGORIES = ['high_school', 'university', 'company', 'npb', 'mlb', 'other'] as const;
export type CareerCategory = typeof CAREER_CATEGORIES[number];
export type CareerRoleMode = 'player' | 'coaching' | 'none';
export type CareerRoleFilters = Partial<Record<CareerCategory, CareerRoleMode>>;

export const categoryName = (category: CareerCategory, locale: Locale): string => {
  const names = {
    high_school: ['高校', 'High school', 'Secundaria'], university: ['大学', 'University', 'Universidad'],
    company: ['社会人', 'Company', 'Empresa'], npb: ['NPB', 'NPB', 'NPB'], mlb: ['MLB', 'MLB', 'MLB'],
    other: ['その他', 'Other', 'Otros'],
  };
  return names[category][locale === 'ja' ? 0 : locale === 'es' ? 2 : 1];
};

export const careerCategory = (item: CareerOrganizationMeta): CareerCategory =>
  item.category ?? (['high_school', 'university', 'company'].includes(item.organizationType)
    ? item.organizationType as CareerCategory : 'other');

export const parseCareerRoles = (values: string[]): CareerRoleFilters => {
  const result: CareerRoleFilters = {};
  for (const value of values) {
    const [category, mode, extra] = value.split(':');
    if (!extra && CAREER_CATEGORIES.includes(category as CareerCategory) && ['player', 'coaching', 'none'].includes(mode)) {
      result[category as CareerCategory] = mode as CareerRoleMode;
    }
  }
  return result;
};

export const appendCareerRoles = (params: URLSearchParams, roles: CareerRoleFilters) => {
  for (const category of CAREER_CATEGORIES) {
    if (roles[category]) params.append('role', `${category}:${roles[category]}`);
  }
};

export const organizationFilterHref = (locale: Locale, slugs: string[], roles: CareerRoleFilters = {}) => {
  const params = new URLSearchParams();
  for (const slug of new Set(slugs)) params.append('organization', slug);
  if (slugs.length) appendCareerRoles(params, roles);
  const path = withLocalePrefix(locale, '/organizations');
  return params.size ? `${path}?${params.toString()}` : path;
};
